export const cdnUrl = 'https://appspowerplaymanager.vshcdn.net/images/winter-sports/minigame/';
//# sourceMappingURL=index.js.map